<template>
  <div>
    <page-loader v-if="loading" message="Loading Equipment Types..." />
    <div v-else-if="errorLoading">
      <span
        >Unable to load Equipment Types at this time. Please try again
        later.</span
      >
    </div>
    <div v-else>
      <div v-if="!filteredEquipmentTypes.length" class="no-results-message">
        <i class="fad fa-question-circle" />
        No Equipment Types Available
      </div>
      <div v-else class="section-spacing-20">
        <equipment-type-card
          v-for="(equipmentType, index) in filteredEquipmentTypes"
          :key="index"
          :equipment-type="equipmentType"
          @edit="handleOnEdit"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";

import PageLoader from "@/components/PageLoader.vue";
import { sortEquipmentTypes } from "@/vuex/modules/equipmentTypes";
import EquipmentTypeCard from "./EquipmentTypeCard.vue";

export default {
  components: {
    EquipmentTypeCard,
    PageLoader
  },
  props: {
    showEdit: {
      type: Boolean,
      default: () => true
    },
    includeArchived: {
      type: Boolean,
      default: () => false
    },
    includeComponentTypeIds: {
      type: Array,
      default: () => []
    }
  },
  emits: ["edit"],
  data() {
    return {
      showAddModal: false,
      errorLoading: false,
      loading: true
    };
  },
  computed: {
    ...mapState(["equipmentTypes", "componentTypes"]),
    filteredEquipmentTypes() {
      const filteredEquipment = this.equipmentTypes.filter((equipmentType) => {
        if (!this.includeArchived) {
          if (equipmentType.archived) return false;
        }
        if (this.includeComponentTypeIds.length) {
          return this.includeComponentTypeIds.some((id) => {
            return equipmentType.component_types
              .map((cp) => cp.id)
              .includes(id);
          });
        }
        return true;
      });
      return sortEquipmentTypes(filteredEquipment);
    }
  },
  async mounted() {
    this.loading = true;
    try {
      await this.refresh();
    } catch (e) {
      // do nothing
    }
    this.loading = false;
  },
  methods: {
    ...mapActions(["fetchEquipmentTypes", "fetchComponentTypes"]),
    handleAddEquipmentType() {
      this.showAddModal = true;
    },
    handleOnEdit(equipmentType) {
      this.$emit("edit", equipmentType);
    },
    async refresh() {
      try {
        await Promise.all([
          this.fetchEquipmentTypes(),
          this.fetchComponentTypes()
        ]);
        this.errorLoading = false;
      } catch (e) {
        this.errorLoading = true;
      }
    }
  }
};
</script>
